import Config from "../../config/Config";
import ErrorHandler from "./errorHandler";
const axios = require("axios");

const baseUrlDev = Config.BaseUrlDev;

const bearer = () => {
  return localStorage.getItem("token_redux").replaceAll('"', "");
};

export const getBeritas = (companyId, page, size, sort, dir, title) => {
  return new Promise((resolve, reject) => {
    axios
      .post(
        `${baseUrlDev}mob_user/get_beritas?companyId=${companyId}&size=${size}&page=${page}&sort=${sort}&dir=${dir}&title=${title}`
      )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const login = (url, data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${baseUrlDev}${url}`, new URLSearchParams(data).toString(), {
        headers: {
          accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getInfoNews = (page, keys, size) => {
  let defaultBool = [{ field: "enable", key: true }];

  var data = {
    search: [],
    tagInSearch: [
      {
        field: "tags",
        key: keys,
      },
    ],
    defaultBool: defaultBool,
  };
  return new Promise((resolve, reject) => {
    axios
      .post(
        `${baseUrlDev}main_a/info/get_info?size=${size}&page=${page}&sort=updateTime&dir=-1`,
        data,
        {
          headers: {
            Authorization: `Bearer ${bearer()}`,
          },
        }
      )
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        resolve(res);
      })
      .catch((err) => {
        console.log(err);
        ErrorHandler(err);
        reject(err);
      });
  });
};
export const getDetailInfo = (id) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${baseUrlDev}main_a/info/info/${id}`, {
        headers: {
          Authorization: `Bearer ${bearer()}`,
        },
      })
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        resolve(res);
      })
      .catch((err) => {
        console.log(err);
        ErrorHandler(err);
        reject(err);
      });
  });
};
